// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageLargeFragmentDoc } from '../imageLarge.fragment.generated';
import { ContentComponentItemFragmentDoc } from './ContentComponentItem.fragment.generated';
export const ComponentTextWithImageFragmentDoc = gql`
    fragment componentTextWithImage on ComponentTextWithImage {
  image {
    ...imageLarge
  }
  padding
  imageFormat
  imagePosition
  content {
    ...contentComponentItem
  }
}
    ${ImageLargeFragmentDoc}
${ContentComponentItemFragmentDoc}`;